import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import routes from 'constants/routes'
import { logout } from 'slices/authSlice'
import { ShieldAlert } from 'lucide-react'

/**
 * Persistent, high-contrast banner shown during a support-impersonation
 * session. Renders nothing otherwise. "Exit" drops the impersonation token
 * (logout), returning the admin to the sign-in screen to resume their own
 * session. Mounted in the app shell so it's always visible.
 */
const ImpersonationBanner = () => {
	const dispatch = useDispatch<any>()
	const navigate = useNavigate()
	const userInfo = useSelector((state: any) => state.userLogin?.userInfo)

	// To a plain /login: the admin resumes their own session, not the
	// impersonated user's page (MYD-541).
	const exit = () => {
		dispatch(logout())
		navigate(routes.LOGIN)
	}

	if (!userInfo?.isImpersonating) return null

	return (
		<div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-warning px-4 py-2 text-center text-sm font-medium text-gray-900">
			<span className="inline-flex items-center gap-1.5">
				<ShieldAlert className="h-4 w-4" />
				Support session — you are viewing as{' '}
				<strong>{userInfo.email}</strong> (read-only)
				{userInfo.impersonatorEmail ? ` · signed in by ${userInfo.impersonatorEmail}` : ''}
			</span>
			<button
				type="button"
				onClick={exit}
				className="rounded-full bg-gray-900 px-3 py-1 text-xs font-semibold text-white transition-colors hover:bg-gray-700"
			>
				Exit support session
			</button>
		</div>
	)
}

export default ImpersonationBanner
